import { Routes } from '@angular/router';

import { ErrorComponent } from './error.component';

export const errorRoute: Routes = [
    {
        path: 'error',
        component: ErrorComponent,
        data: {
            userRoles: [],
            pageTitle: 'FDEGateway'
        }
    },
    {
        path: 'accessdenied',
        component: ErrorComponent,
        data: {
            userRoles: [],
            pageTitle: 'FDEGateway',
            error403: true
        }
    },
    {
        path: '404',
        component: ErrorComponent,
        data: {
            userRoles: [],
            pageTitle: 'FDEGateway',
            error404: true
        }
    },
    {
        path: '**',
        redirectTo: '/404'
    }
];
